// ##### 25-04-30 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-12
import React, { useEffect, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';

// ##### Komarov 2025-07-14
const CooperationMobile = ({
  pages,
  title,
  isWhiteLabelSet,
  companyCipher,
  sidebarListWidth,
}) => {
  const cooperationRef = useRef();
  const cooperationItemsRef = useRef();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    cooperationItemsRef.current.style.right = `${sidebarListWidth}px`;
    cooperationItemsRef.current.style.top = `${cooperationRef.current.offsetTop}px`;
  }, [cooperationItemsRef.current]);

  const removeCooperationItems = () => {
    const cooperationItemsclassList = cooperationItemsRef.current.classList;
    if (!cooperationItemsclassList.contains('CooperationMobileItemsHide')) {
      cooperationItemsclassList.add('CooperationMobileItemsHide');
    }
  };

  const toggleCooperationItems = e => {
    cooperationItemsRef.current.classList.toggle('CooperationMobileItemsHide');
    e.stopPropagation();
  };

  return (
    <OutsideClickHandler onOutsideClick={removeCooperationItems}>
      <a
        ref={cooperationRef}
        role="button"
        data-component="CooperationMobile"
        onClick={toggleCooperationItems}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleCooperationItems();
          }
        }}
      >
        {/* ##### 26-06-30 Komarov */}
        <h4>{typeof title === 'string' ? title : title?.[0]?.text ?? ''}</h4>
      </a>
      <div
        className="CooperationMobileItemsHide"
        data-component="CooperationMobileItems"
        ref={cooperationItemsRef}
      >
        {pages.map(page => {
          return (
            // ##### 24-03-04 Komarov

            <LocalizationNavLink
              // ##### 25-04-21 Komarov
              to={
                (isWhiteLabelSet &&
                  `/ref${companyCipher}/sitepages/?name=${page.name}&spid=${page.id}`) ||
                `/sitepages/?name=${page.name}&spid=${page.id}`
              }
              key={uniqueId()}
              onClick={removeCooperationItems}
            >
              {/* ##### 26-06-30 Komarov */}
              <h4>{parse(page.title?.[0]?.text ?? '')}</h4>
            </LocalizationNavLink>
          );
        })}
      </div>
    </OutsideClickHandler>
  );
};

export default CooperationMobile;
